<template>
<el-main id="contact">
      <h1>免费咨询服务-欢迎预约</h1>
      
      <ul class="intro">
        <li>
        <h2>· 数字互联战略初诊 ·</h2>
        <p>从数字化与互联趋势出发，为现有目标给出初步可行性建议</p>
        </li>
        <li>
         <h2>· 团队创新能力初诊 ·</h2>
        <p>发现团队架构、能力与现有互联业务目标之间匹配度</p>
        </li>
        <li>
          <span class="mail"><h3>预约与合作邮件请发至：</h3>
          <h2>j@wetouch.cn</h2>
          </span>
        </li>

      </ul>

    </el-main>

</template>

<script>

export default{
    name:'ContactInfo'
    }
</script>
